import React, { useState, useEffect } from 'react';
import AdminSidebar from '../../components/ui/AdminSidebar';
import ExecutiveSummaryCards from './components/ExecutiveSummaryCards';
import BusinessHealthCards from './components/BusinessHealthCards';
import SaaSMetricsCards from './components/SaaSMetricsCards';
import RevenueChart from './components/RevenueChart';
import ActivityFeed from './components/ActivityFeed';
import QuickActions from './components/QuickActions';
import SystemAlerts from './components/SystemAlerts';
import TopPerformers from './components/TopPerformers';
import GamingAnalyticsDashboard from './components/GamingAnalyticsDashboard';
import { clearDashboardCache } from '../../utils/dashboardService';

import Button from '../../components/ui/Button';

const AdminDashboard = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // Update every minute

    return () => clearInterval(timer);
  }, []);

  const handleRefresh = async () => {
    setRefreshing(true);
    // Clear cache to force fresh data
    clearDashboardCache();
    // Give time for components to refresh
    await new Promise(resolve => setTimeout(resolve, 1500));
    setRefreshing(false);
    // Trigger page refresh to reload all components
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-background">
      <AdminSidebar />
      
      {/* Main Content */}
      <div className="lg:pl-72">
        <div className="sticky top-0 z-40 bg-background/95 backdrop-blur-md border-b border-border lg:hidden">
          <div className="px-4 py-4">
            <h1 className="text-xl font-bold text-foreground">Admin Dashboard</h1>
          </div>
        </div>

        <main className="p-4 lg:p-8 pt-20 lg:pt-8 pb-20 lg:pb-8">
          {/* Header */}
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-8">
            <div>
              <h1 className="text-2xl lg:text-3xl font-bold text-foreground mb-2">
                Admin Dashboard
              </h1>
              <p className="text-muted-foreground">
                Platform overview and management tools • {currentTime.toLocaleDateString()} {currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </p>
            </div>
            
            <div className="flex items-center space-x-3 mt-4 lg:mt-0">
              <Button 
                variant="outline" 
                size="sm" 
                iconName="Download"
                onClick={() => console.log('Export dashboard data')}
              >
                Export Data
              </Button>
              <Button 
                variant="outline" 
                size="sm" 
                iconName="RefreshCw"
                loading={refreshing}
                onClick={handleRefresh}
              >
                Refresh
              </Button>
              <Button 
                variant="default" 
                size="sm" 
                iconName="Settings"
                onClick={() => console.log('Open dashboard settings')}
              >
                Settings
              </Button>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="mb-8">
            <QuickActions />
          </div>

          {/* Key Business Metrics - Netflix-style dashboard */}
          <SaaSMetricsCards />

          {/* Business Health Indicators */}
          <BusinessHealthCards />

          {/* System Alerts - Critical Issues */}
          <div className="mb-8" id="system-alerts">
            <SystemAlerts />
          </div>

          {/* Revenue Analytics Chart */}
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mb-8">
            <RevenueChart />
            <TopPerformers />
          </div>

          {/* Netflix-Style Gaming Analytics Dashboard */}
          <div className="mb-8">
            <GamingAnalyticsDashboard />
          </div>

          {/* Activity Feed */}
          <div className="mb-8">
            <ActivityFeed />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminDashboard;
